<template>
    <div>
        <b-modal size="xl" button-size="md" ref="finder" hide-footer :id="this.id" :title="prefix + title">
            <GarantiaContratoList :showCamposCustomizados="true" @close="rowSelect" :prefix="prefix" />
        </b-modal>

        <lg-form-input-finder v-model="localObject" fieldDescription="descricao" :label="label"
            invalidFeedback="Garantia Contrato deve ser informado!" description="" @handleClean="rowSelect">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import GarantiaContratoList from "@/modules/cadastros/garantia-contrato/GarantiaContratoList.vue";

export default {
    components: {
        LgFormInputFinder,
        GarantiaContratoList,
    },

    props: {
        id: String,
        onDblClickLocalArmazenamentoList: Function,
        value: Object,
        label: {
            type: String,
            default: 'Garantia Contrato:'
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Garantia Contrato",
        },

    },


    data() {
        return {
            localObject: this.value,
            garantiaContrato: "",
            fields: [
                {
                    key: "nome",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        };
    },

    methods: {

        async show() {
            await this.$refs.finder.show();
            this.$refs.finder.show();
        },

        async rowSelect(item) {
            this.localObject = item;
            this.$emit("close", item);
            this.$refs.finder.hide();

        },
    },
};
</script>
